import React from 'react';
import './InputTag.css';
import { connect } from "react-redux";

class InputTag extends React.Component {
    constructor() {
      super();
      

    }
    
  
    render() {
      const { commonCoreIndicators } = this.props;
       let headingStyle = { display: 'inline', marginRight: '10px', fontSize: 'initial !important', top: '10px' };
  
      return (
         <div style={{ width: '95%', marginTop: '20px', display: 'none' }}>
       <label style={headingStyle}><strong>Common Core Indicators</strong></label>
        <div className="input-tag" style={{ width: '100%', marginTop: '2px' }}>
        <ul className="input-tag__tags">
            { commonCoreIndicators.map((tag, i) => (
              <li key={tag}>
                {tag}
                <button type="button" onClick={() => { this.props.onRemoveTag(i); }}>+</button>
              </li>
            ))}
            <li className="input-tag__tags__input">
            <input type="text" onKeyDown={this.props.onTagsInput} ref={this.props.handleTagInput}></input>
            </li>
          </ul>
        </div>
        </div>
      );
    }
  }
  
  function mapStateToProps(state) {
    return { ...state };
}

export default connect(mapStateToProps)(InputTag);
  